import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const reset = () => null;

/**
 * @param {string} _
 * @param {import('modules/statistics/types').ExportStatisticsFailureAction} action
 * @returns {string}
 */
const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.STATISTICS_DEALER_EXPORT]: reset,
  [types.STATISTICS_DEALER_EXPORT_FAILURE]: setError,
});
